import { MutationTree } from "vuex";
import DocumentHistory from "@/types/documents/document/DocumentHistory";
import { IDataProvider } from "@/store";
import { IDocumentHistoryState } from "@/store/modules/documentHistory/state";

export enum DocumentHistoryMutations {
  SET_ONE = "SET_ONE_DOCUMENT_CONSTRUCTOR",
  SET_ALL = "SET_ALL_DOCUMENT_CONSTRUCTOR",
  SET_LAZY_DATA = "SET_LAZY_DATA_DOCUMENT_CONSTRUCTOR",
}

export const mutations: MutationTree<IDocumentHistoryState> = {
  [DocumentHistoryMutations.SET_ONE](state, payload: DocumentHistory) {
    state.documentHistory = payload;
  },
  [DocumentHistoryMutations.SET_ALL](state, payload: DocumentHistory[]) {
    state.documentHistories = payload;
  },
  [DocumentHistoryMutations.SET_LAZY_DATA](
    state,
    payload: IDataProvider<DocumentHistory>
  ) {
    state.dataProvider = payload;
  },
};
